var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-empty is-empty-component"},[_c('img',{staticClass:"empty-icon",attrs:{"src":require("@/assets/image/icon/empty.png"),"alt":""}}),_vm._t("desc")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }